import { TextField } from '@mui/material';
import { useField } from 'formik';

const MyDurationInput = ({ label, error: errorProp, helperText: helperTextProp, ...props }) => {
  const [field, meta, helpers] = useField(props);

  const handleChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[^0-9:]/g, '');

    if (value.length === 2 || value.length === 5) {
      if (!value.endsWith(':')) value += ':';
    }

    if (value.length > 8) return;

    helpers.setValue(value);
  };

  return (
    <TextField
      {...field}
      {...props}
      value={field.value || ''}
      onChange={handleChange}
      label={label}
      placeholder="HH:mm:ss"
      fullWidth
      error={errorProp ?? (meta.touched && Boolean(meta.error))}
      helperText={helperTextProp ?? (meta.touched && meta.error ? meta.error : 'Formato: 00:00:00')}
      inputProps={{
        maxLength: 8,
        inputMode: 'numeric',
      }}
    />
  );
};

export default MyDurationInput;
